import type { NotificationChannel, NotificationPrefs, NotificationType } from "@cafe/shared";
import { useQuery } from "@tanstack/react-query";
import { api, http } from "@/shared/api/client";

export type NotificationDto = { id: string; type: string; title: string; body: string; data: unknown; branchId: string | null; readAt: string | null; createdAt: string };
export type NotificationSettings = {
  prefs: NotificationPrefs; email: string | null; telegramBot: string;
  /** Типы, доступные по правам ролей пользователя */
  types: { type: NotificationType; channels: NotificationChannel[] }[];
  telegram: { linked: true; username: string | null; linkedAt: string } | { linked: false };
};

export const notificationKeys = { list: ["notifications"] as const, settings: ["notification-settings"] as const };

/** Последние 30 уведомлений и число непрочитанных (meta.unread). */
export const useNotifications = () =>
  useQuery({
    queryKey: notificationKeys.list,
    queryFn: () => api<{ items: NotificationDto[]; meta: { unread?: number } }>("GET", "/notifications", { query: { pageSize: 30 }, withMeta: true, branch: false }),
    staleTime: 60_000,
  });

export const notificationsApi = {
  readAll: () => http.post("/notifications/read", { all: true }),
  read: (ids: string[]) => http.post("/notifications/read", { ids }),
  settings: () => http.get<NotificationSettings>("/me/notification-settings"),
  save: (p: Partial<NotificationPrefs>) => http.put<NotificationSettings>("/me/notification-settings", p),
  link: () => http.post<{ url: string; expiresAt: string }>("/me/telegram/link", {}),
  unlink: () => http.delete("/me/telegram"),
};
